export default {
      id: "logout-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#logout-usage",
      toString: function () {
        return this.url;
      }
    }